

const FAQ = () => {


    return (
        <iframe
            title={'faq'}
            width={"100%"}
            style={{border: "none", maxWidth: "820px", margin: "0 auto"}}
            src="https://docs.google.com/document/d/e/2PACX-1vTL0uWEnegn6PEN0DDdaXtNx62CpAtyyj_wB__0YyeicA8TjxQpUjaTU3UtT96FL1bliANqk1ItFtbs/pub?embedded=true"
        />
    )
}

export default FAQ;